import * as React from 'react';
import {useStyletron} from "baseui";

export function PlanImage({ src, alt }) {
    const [css] = useStyletron();
    
    return (
        <div className={css({ display: 'flex', justifyContent: 'center' })}>
            <img 
                className={css({ borderRadius: '12px' })} 
                width={"85%"} 
                height={"85%"} 
                src={src} 
                alt={alt}
            />
        </div>
    );
}
